import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import Home from '@/pages/home/page';
import Article from '@/pages/article/page';
import About from '@/pages/about/page';
import Faq from '@/pages/faq/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'article/:id', element: <Article /> },
      { path: 'about', element: <About /> },
      { path: 'faq', element: <Faq /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;